var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurved = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.109 5.967a3.25 3.25 0 0 0-4.048 1.59l-.78 1.558a4.75 4.75 0 0 1-5.916 2.323l-.628-.236a.75.75 0 0 1 .527-1.404l.628.235a3.25 3.25 0 0 0 4.048-1.59l.779-1.558a4.75 4.75 0 0 1 5.916-2.323l.629.236a.75.75 0 1 1-.527 1.404z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurved);
export default ForwardRef;